import { SortOrderType } from '@repo/common';

import { UrlSearchFilterProperty } from '@/constants';
import { useGetBalanceHistoryQuery } from '@/features/slice/balance-history/balance-history-api-slice';
import { useUrlFilter } from '@/hooks';
import { mapDateObjectToString } from '@/utils/mappers/map-date-object-to-string.mapper';

export const useCashBox = () => {
    const { getSearchFilter } = useUrlFilter({
        defaultSortBy: 'date',
        defaultSortOrder: SortOrderType.ASC,
    });

    const startDate = getSearchFilter(UrlSearchFilterProperty.DATE_FROM);
    const endDate = getSearchFilter(UrlSearchFilterProperty.DATE_TO);

    const queryParams: Record<string, string | number> = {
        page: 1,
        limit: 1000,
        sort_by: 'date',
        sort_order: SortOrderType.DESC,
    };

    if (startDate) {
        queryParams.start_date = mapDateObjectToString(new Date(startDate));
    }

    if (endDate) {
        queryParams.end_date = mapDateObjectToString(new Date(endDate));
    }

    const { data, isError, isFetching, isLoading, isSuccess, error } =
        useGetBalanceHistoryQuery(queryParams);

    return {
        data,
        error,
        isError,
        isFetching,
        isLoading: isLoading || isFetching,
        isSuccess,
    };
};
